import { Route, Routes } from 'react-router-dom';
import App from 'App';
import SignIn from 'components/authentication/SignIn/SignIn';
import { AVAILABLE_PATHS, pathKeys } from 'types/types';
import WrongRoute from 'components/WrongRoute/WrongRoute';
import ProtectedRoute from 'AppRoutes/ProtectedRoute';
import JobDetailsPage from 'components/JobDetailsPage/JobDetailsPage';
import SignInPage from 'pages/SignInPage';
import TableDetailsPage from 'pages/TableDetailsPage';
import JobsTablePage from 'pages/JobsTablePage';
import MetricsPage from 'pages/MetricsPage';
import OverviewPage from 'pages/OverviewPage';
import ConnectPageLayout from 'components/ChidoriConnect/ConnectPageLayout/ConnectPageLayout';
import useSignedURL from 'hooks/useSignedURL';

// Safe helper to fetch and guarantee defined path strings
const getPath = (key: pathKeys): string => {
  const path = AVAILABLE_PATHS.get(key);
  if (!path) {
    console.warn(`[Routing] Path for key "${key}" is not registered in AVAILABLE_PATHS.`);
    return '';
  }
  return path;
};

function ClusterIndexRoute() {
  const { isSignedURL } = useSignedURL();
  return isSignedURL ? <JobsTablePage /> : <OverviewPage />;
}

function AppRoutes() {
  return (
    <Routes>
      {/* All Clusters Routes */}
      <Route
        path={getPath(pathKeys.ALL_CLUSTERS_SIGN_IN)}
        element={<SignIn />}
      />
      <Route
        path={getPath(pathKeys.ALL_CLUSTERS)}
        element={
          <ProtectedRoute redirectPath={getPath(pathKeys.ALL_CLUSTERS_SIGN_IN)}>
            <App />
          </ProtectedRoute>
        }
      />

      {/* Single Cluster Routes */}
      <Route
        path={getPath(pathKeys.SIGN_IN)}
        element={<SignIn />}
      />
      <Route path={getPath(pathKeys.ROOT)} element={<SignInPage />}>
        <Route index element={<ClusterIndexRoute />} />
        <Route
          path={getPath(pathKeys.JOBS)}
          element={<JobsTablePage />}
        />
        <Route
          path={getPath(pathKeys.JOB_DETAILS)}
          element={<JobDetailsPage />}
        />
        <Route
          path={getPath(pathKeys.TABLE_DETAILS)}
          element={<TableDetailsPage />}
        />
        <Route
          path={getPath(pathKeys.METRICS)}
          element={<MetricsPage />}
        />
        <Route
          path={getPath(pathKeys.CHIDORI_CONNECT)}
          element={<ConnectPageLayout />}
        />
        <Route path="*" element={<WrongRoute />} />
      </Route>

      <Route path="*" element={<WrongRoute />} />
    </Routes>
  );
}

export default AppRoutes;
